import * as React from "react";
const SvgShieldCrossedOut = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M13.7744 2.93245C13.4683 2.95801 13.1544 2.97181 12.8343 2.97181C10.7017 2.97181 8.83408 2.38258 7.80079 1.5C6.7675 2.38241 4.89983 2.97181 2.76745 2.97181C2.44723 2.97181 2.13348 2.95801 1.82722 2.93245C1.74945 4.69794 1.78302 7.71069 2.78639 9.88694C4.17613 12.9014 7.79913 14.4992 7.80079 14.5C7.80245 14.4992 11.4253 12.9014 12.8152 9.88694C13.8184 7.71069 13.8521 4.69794 13.7744 2.93245ZM11.8686 9.44002C10.9259 11.4851 8.71892 12.8316 7.80079 13.3217C6.87701 12.8289 4.67533 11.4844 3.73277 9.44002C3.30586 8.51404 2.83109 6.84762 2.84439 4.02865C4.75526 4.01687 6.53851 3.56557 7.80079 2.79334C9.0629 3.56557 10.8463 4.01687 12.7572 4.02865C12.7705 6.84728 12.2957 8.51387 11.8686 9.44002Z",
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.68147 4.48835C7.58227 4.38793 7.43021 4.37885 7.34214 4.46816L4.25324 7.59445C4.16517 7.68377 4.17381 7.83768 4.27335 7.93809C4.37256 8.03851 4.52444 8.04743 4.61268 7.95828L7.70142 4.832C7.78982 4.74268 7.78068 4.58877 7.68147 4.48835Z",
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.5163 6.05386L5.8198 7.77074C5.73172 7.86006 5.74036 8.0138 5.8399 8.11422C5.93894 8.21481 6.091 8.22356 6.17924 8.13441L7.87557 6.41769C7.96398 6.32821 7.95501 6.1743 7.8558 6.07405C7.75626 5.97363 7.60437 5.96454 7.5163 6.05386Z",
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M2.80078 13.4521L14.3027 2.11523",
	stroke: "white",
	strokeLinecap: "round"
}));
export default SvgShieldCrossedOut;
